import * as constants from "../constants/CONSTANT";
import authApi from "./authApi";

import { getAxios, getAxiosFile, getAxiosMultipart } from "../utils/helper";
const instituteApi = {
  // ************************ Users ***********************************
  //..... Fetch Users ........
  async fetchUsers() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/users"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //   //.................... Fetch Login Users ...................................
  //   async getLoginUserData() {
  //     const instance = getAxios();
  //     const { data } = await instance.get(
  //       `${constants.API_BASE_URL + "/api/auth/getuser"}`
  //     );
  //     if (data.status === 401) {
  //       authApi.logout();
  //     }

  //     if (data) {
  //       return data;
  //     }
  //     return null;
  //   },

  async createUser(user) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/auth/create_user"}`,
        user
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //........ Fetch Lead By Id .........
  async fetchUserById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/users/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //....... Save Login Users ...................................
  async saveUser(user) {
    const instance = getAxios();
    try {
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/auth/" + user.id}`,
        user
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },


  async saveStaffMemberEditProfile(userid, selectedFiles, staffMember) {
    //console.log("Enter staff data", userid);
    //console.log('selectedFiles',selectedFiles)
    const formData = new FormData();
    formData.append('file', selectedFiles);
    formData.append('staffRecord', staffMember);
    //console.log([...formData])
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL +
      "/api/auth/" +
      userid + "/profile",
      {
        method: "PUT",
        mode: "cors",
        headers: {

          Authorization: token,
        },
        body: formData,
      }
    );
    //console.log(response);
    return await response.json();
  },

  // ************************ Users End Here ***********************************

  // ************** Financial Years **********************************

  //---------------------------------------Active Financial Year List-----------------------------------
  async fetchAllActiveFinancialYears() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/financialyears/active"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },
  // ---------------------------------Fetch Financial Years List ----------------------------------------
  async fetchAllFinancialYears() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/financialyears/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // ---------------------------------Create or Update Financial Years  ----------------------------------------
  async createFinancialYear(isFinancialYear) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/financialyears"}`,
      isFinancialYear
    );
    if (data.status === 401) {
      authApi.logout();
    }
    console.log(data);
    if (data) {
      return data;
    }
    return null;
  },
  async saveFinancialYear(isFinancialYear) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/financialyears/" + isFinancialYear.id}`,
      isFinancialYear
    );
    if (data.status === 401) {
      authApi.logout();
    }
    console.log("data", data);
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Financial Years ----------------------------------------//
  async deleteFinancialYear(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/financialyears/" + id}`
    );
    if (data.status === 401) {
      authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  // ************** Branch  **********************************

  // ---------------------------------Fetch Branch List ----------------------------------------
  async fetchAllBranch() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/branches/"}`
    );
    if (data.status === 401) {
      authApi.logout();
    }
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Update Branch  ----------------------------------------
  async createBranch(isBranch) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/branches"}`,
      isBranch
    );
    if (data.status === 401) {
      authApi.logout();
    }
    console.log(data);
    if (data) {
      return data;
    }
    return null;
  },
  async saveBranch(isBranch) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/branches/" + isBranch.id}`,
      isBranch
    );
    if (data.status === 401) {
      authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Branch  ----------------------------------------//
  async deleteBranch(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/branches/" + id}`
    );
    if (data.status === 401) {
      authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },
  // ************** Items  **********************************

  // ---------------------------------Fetch Items List ----------------------------------------
  async fetchAllItem() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/items/"}`
    );
    if (data.status === 401) {
      authApi.logout();
    }
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Items Branch  ----------------------------------------
  async createItem(isItem) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/items"}`,
      isItem
    );
    console.log(data);
    if (data) {
      return data;
    }
    return null;
  },
  async saveItem(isItem) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/items/" + isItem.id}`,
      isItem
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Items  ----------------------------------------//
  async deleteItem(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/items/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },

  // ************** Supplier  **********************************

  // ---------------------------------Fetch Supplier List ----------------------------------------
  async fetchAllSupplier() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/suppliers/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Supplier  ----------------------------------------
  async createSupplier(isSupplier) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/suppliers"}`,
      isSupplier
    );
    console.log(data);
    if (data) {
      return data;
    }
    return null;
  },
  async saveSupplier(isSupplier) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/suppliers/" + isSupplier.id}`,
      isSupplier
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Supplier  ----------------------------------------//
  async deleteSupplier(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/suppliers/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },
  //End Here
  // ************** Client  **********************************

  // ---------------------------------Fetch Client List ----------------------------------------
  async fetchAllClient() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clients/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // ------------------------ Fetch Client By Id  ----------------------------------------//
  async fetchAllClientById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clients/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Client  ----------------------------------------
  async createClient(isClient) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/clients"}`,
      isClient
    );
    if (data) {
      return data;
    }
    return null;
  },
  async saveClient(isClient) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/clients/" + isClient.id}`,
      isClient
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Client  ----------------------------------------//
  async deleteClient(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/clients/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },
  //End Here

  // ************** Transporters  **********************************

  // ---------------------------------Fetch Transporters List ----------------------------------------
  async fetchAllTransporters() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/transporters/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //------------------------------- Fetch Trasporter By Vechicle Id ---------------

  async fetchAllVechicleByTrasporterId(id) {
    const instance = getAxios();
    const { data } = await instance.get(`${constants.API_BASE_URL + "/api/vehicles/trasport/" + id}`,);
    if (data) {
      return data;
    }
    return null;
  },

  //------------------------------- Fetch Suppliers By Vechicle Id (Supplier Report Dropdown) ---------------

  async fetchAllVechicleBySupplierId(id) {
    const instance = getAxios();
    const { data } = await instance.get(`${constants.API_BASE_URL + "/api/vehicles/suppliers/" + id}`,);
    if (data) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Transporters  ----------------------------------------
  async createTransporters(trasportData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/transporters"}`,
      trasportData
    );
    if (data) {
      return data;
    }
    return null;
  },
  async saveTransporters(trasportData) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/transporters/" + trasportData.id}`,
      trasportData
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Transporters  ----------------------------------------//
  async deleteTransporters(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/transporters/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },


  // ************** Driver  **********************************

  // ---------------------------------Fetch Driver List ----------------------------------------
  async fetchAllDrivers() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/drivers/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Driver  ----------------------------------------
  async createDrivers(driversData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/drivers"}`,
      driversData
    );
    if (data) {
      return data;
    }
    return null;
  },
  async saveDrivers(driversData) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/drivers/" + driversData.id}`,
      driversData
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Driver  ----------------------------------------//
  async deleteDrivers(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/drivers/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },


  // ************** Vehicles  **********************************

  // ---------------------------------Fetch Vehicles List ----------------------------------------
  async fetchAllVehicles() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/vehicles/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Vehicles  ----------------------------------------
  async createVehicles(vehiclesData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/vehicles"}`,
      vehiclesData
    );
    if (data) {
      return data;
    }
    return null;
  },
  async saveVehicles(vehiclesData) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/vehicles/" + vehiclesData.id}`,
      vehiclesData
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Vehicles  ----------------------------------------//
  async deleteVehicles(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/vehicles/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },


  // ------------------------ Fetch By Vehicle Number  ----------------------------------------//
  async fetchByVechileNumber(vehicle_number, financial_year_id) {
    console.log("vehicle_number:", vehicle_number, "financial_year_id:", financial_year_id);
    const instance = getAxios();
    // const { data } = await instance.get(
    //   `${constants.API_BASE_URL}/api/vehicles/vechno?vehicle_number=${vehicle_number}&financial_year_id=${financial_year_id}`
    // )
    const { data } = await instance.get(
      `${constants.API_BASE_URL}/api/vehicles/vechno`,
      {
        params: {
          vehicle_number,
          financial_year_id,
        },
      }
    );
    if (data) {
      return data;
    }
    return null;
  },


  // ************** Country  **********************************

  // ---------------------------------Fetch Country List ----------------------------------------
  async fetchAllCountry() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/countries/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Country  ----------------------------------------
  async createCountry(countryData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/countries"}`,
      countryData
    );
    if (data) {
      return data;
    }
    return null;
  },
  async saveCountry(countryData) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/countries/" + countryData.id}`,
      countryData
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Country  ----------------------------------------//
  async deleteCountry(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/countries/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },


  // ************** State  **********************************

  // ---------------------------------Fetch State List ----------------------------------------
  async fetchAllStates() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/states/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or State  ----------------------------------------
  async createState(stateData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/states"}`,
      stateData
    );
    if (data) {
      return data;
    }
    return null;
  },
  async saveState(stateData) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/states/" + stateData.id}`,
      stateData
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete State  ----------------------------------------//
  async deleteState(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/states/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },


  // ************** City  **********************************

  // ---------------------------------Fetch City List ----------------------------------------
  async fetchAllCity() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/cites/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or City  ----------------------------------------
  async createCity(cityData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/cites"}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },
  async saveCity(cityData) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/cites/" + cityData.id}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete City  ----------------------------------------//
  async deleteCity(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/cites/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },



  // ************** Challan  **********************************

  //................... Fetch All Challan Counts ................................
  async fetchChallanCount(filterDate) {
    console.log("Filter Date on Api", filterDate)
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL}/api/challans/total/${filterDate.month}/${filterDate.financial_year_id}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },



  //................... Fetch All Challan Commision Counts ................................
  async fetchChallanCommisionCount(filterDate) {
    console.log("Filter Date on Api", filterDate)
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL}/api/challans/comi/total/${filterDate.month}/${filterDate.financial_year_id}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },


  //................... Fetch All Challan Commision Counts ................................
  async fetchChallanCurrentMonth(filterDate) {
    console.log("Filter Date on Api", filterDate)
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL}/api/challans/current/total/${filterDate.month}/${filterDate.financial_year_id}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },


  //................... Fetch All Challan Commision Counts ................................
  async fetchUserwiseChallanCurrentMonth(filterDate) {
    console.log("Filter Date on Api", filterDate)
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL}/api/challans/user/current/total/${filterDate.month}/${filterDate.financial_year_id}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },


  //................... Fetch All Invoice Amounts Commision Counts ................................
  async fetchInvoiceCurrentMonthDasboard(filterDate) {
    console.log("Filter Date on Api", filterDate)
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL}/api/clientinvoicepayments/current/total/${filterDate.month}/${filterDate.financial_year_id}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },


  //................... Fetch All Invoice Amounts By Vechile Id ................................
  async fetchInvoiceCurrentMonthDasboardByVechicleId(filterDate) {
    console.log("Filter Date on Api", filterDate)
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL}/api/clientinvoicepayments/current/${filterDate}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // ---------------------------------Fetch Challan List ----------------------------------------
  async fetchAllChallan() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/challans/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // -------------------------- Fetch Filter Challan Data -----------------------------------------
  async fetchAllFilterChallan(challanData) {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/challans/datarec/filters"}`, { params: challanData, }
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // ---------------------------- Get Challan Details By Challan No --------------------------------
  async fetchChallanDetailsByChallanNo(challanData) {
    try {
      const instance = getAxios();
      const { challan_no, financial_year_id, branch_id } = challanData;

      console.log("object", challanData);

      const response = await instance.get(
        `${constants.API_BASE_URL}/api/challans/details`,
        {
          params: {
            challan_no,
            financial_year_id,
            branch_id
          },
        }
      );

      if (response?.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching challan details:", error);
    }
  },

  // ---------------------------- Get Challan Details By GR No --------------------------------
  async fetchChallanDetailsByGRNo(challanData) {
    try {
      const instance = getAxios();
      const { gr_no, financial_year_id, branch_id } = challanData;

      console.log("object", challanData);

      const response = await instance.get(
        `${constants.API_BASE_URL}/api/challans/details/grno`,
        {
          params: {
            gr_no,
            financial_year_id,
            branch_id
          },
        }
      );

      if (response?.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching challan details:", error);
    }
  },


  // ---------------------------- Get Challan Details By Challan Number For (Trip) --------------------------------
  async fetchChallanDetailsForTrip(challanData) {
    try {
      const instance = getAxios();
      const { challan_id, financial_year_id, branch_id } = challanData;

      console.log("object", challanData);

      const response = await instance.get(
        `${constants.API_BASE_URL}/api/challans/details/challanno`,
        {
          params: {
            challan_id,
            financial_year_id,
            branch_id,
          },
        }
      );

      if (response?.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching challan details:", error);
    }
  },


  //----------------------Get Challan By Id -------------------------------------
  async fetchChallanById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/challans/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },

  //----------------------Get Challan By Vehicle Id -------------------------------------
  async fetchChallanByVehicleId(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/challans/vehicle/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },

  //----------------------Get Challan By Client Id -------------------------------------
  async fetchChallanByClientId(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/challans/client/" + id}`);
    if (data) {
      return data;
    }
    if (data.status === 401) {
      authApi.logout();
    }
    return null;
  },


  //----------------------Get Challan By Client Id (For Invoice Genration) -------------------------------------
  async fetchChallanByClientIdInvoice(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/challans/client/adchall/" + id}`);
    if (data) {
      return data;
    }
    if (data.status === 401) {
      authApi.logout();
    }
    return null;
  },

  // --------------------------------- Create or Challan  ----------------------------------------
  async createChallan(cityData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/challans"}`,
      cityData
    );

    if (data) {
      return data;
    }
    return null;
  },
  async saveChallan(cityData) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/challans/" + cityData.id}`,
      cityData
    );

    if (data) {
      return data;
    }
    return null;
  },

  // For Bulk upload feature 09 Jan 2025
  async uploadCSVFile(formData) {
    //console.log('pid', pid, 'formData', formData)
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/challans/upload/",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Authorization": token,
        },
        body: formData,
      }
    );

    return await response.json();
  },

  // ------------------------ Delete Challan  ----------------------------------------//
  async deleteChallan(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/challans/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },

  // ************** Advance Challan  **********************************

  // ---------------------------------Fetch Advance Challan List ----------------------------------------
  async fetchAllAdvanceChallan() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/advancechallans/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // -------------------------- Fetch Filter Advance Challan Data -----------------------------------------
  async fetchAllFilterAdvanceChallan(challanData) {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/advancechallans/datarec/filters"}`, { params: challanData, }
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //----------------------Get Advance Challan By Id -------------------------------------
  async fetchAdvanceChallanById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/advancechallans/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },

  //----------------------------- Trip Challan ---------------------------------
  // --------------------------------- Create or Trip Challan  ----------------------------------------
  async createTripChallan(cityData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/tripchallans"}`,
      cityData
    );

    if (data) {
      return data;
    }
    return null;
  },
  async saveTripChallan(cityData) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/tripchallans/" + cityData.id}`,
      cityData
    );

    if (data) {
      return data;
    }
    return null;
  },

  //................... Fetch All Trip Challans ................................
  async fetchTripChallans() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/tripchallans/"}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },


  //.............. Fetch Trip Challans By Id .............................
  async fetchTripChallanById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/tripchallans/" + id}`
    );
    if (data.status === 401) {
      authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },


  // .......... Delete Trip Challan .............................
  async deleteTripChallan(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/tripchallans/" + id}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Update Advance Challan  ----------------------------------------
  async createAdvanceChallan(cityData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/advancechallans"}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },
  async saveAdvanceChallan(cityData) {
    console.log("Advance", cityData.id);
    console.log(`${constants.API_BASE_URL + "/api/advancechallans/" + cityData.id}`);
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/advancechallans/" + cityData.id}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Advance Challan  ----------------------------------------//
  async deleteAdvanceChallan(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/advancechallans/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },

  // ************** Trip Advance Challan  **********************************

  // ---------------------------------Fetch Tip Advance Challan List ----------------------------------------
  async fetchAllTripAdvanceChallan() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/tripadvancechallans/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Trip Advance Challan  ----------------------------------------//
  async deleteTripAdvanceChallan(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/tripadvancechallans/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Update Trip Advance Challan  ----------------------------------------
  async createTripAdvanceChallan(cityData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/tripadvancechallans"}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },
  async saveTripAdvanceChallan(cityData) {
    console.log("Advance", cityData.id);
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/tripadvancechallans/" + cityData.id}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },

  // -------------------------- Fetch Filter Advance Challan Data -----------------------------------------
  async fetchAllFilterTripAdvanceChallan(challanData) {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/tripadvancechallans/datarec/filters"}`, { params: challanData, }
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //----------------------Get Trip Advance Challan By Id -------------------------------------
  async fetchTripAdvanceChallanById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/tripadvancechallans/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },
  // *******************************Contact******************************************

  //   //................... Create Contact ................................
  async createContact(contacts) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/contacts/"}`,
      contacts
    );

    if (data) {
      return data;
    }
    return null;
  },


  //   //................... Create Contact (External Enquiry Form)................................
  async createContactEnquiry(enquiryDetails) {

    let response = await fetch(
      constants.API_BASE_URL + "/api/contacts/enquiry",
      {
        method: "post",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          // Authorization: token,
        },
        body: JSON.stringify(enquiryDetails),
      }
    );

    const result = await response.json();
    ////console.log("current record from api  in fetch =>", result);
    if (result) {
      console.log('Result in fetch =>', result)
      return result;
    }
    return null;
  },

  async saveContact(contacts) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/contacts/" + contacts.id}`,
      contacts
    );
    if (data) {
      return data;
    }
    return null;
  },

  //................... Fetch All Contact ................................
  async fetchContacts() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/contacts/"}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //................... Fetch All Supplier Contact ................................
  async fetchContactsSupllier() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/contacts/supplier"}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //................... Fetch All Contact ................................
  async fetchContact() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/contacts/"}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },


  //.............. Fetch Contact By Id .............................
  async fetchContactById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/contacts/" + id}`
    );
    if (data.status === 401) {
      authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },


  // .......... Delete Contact .............................
  async deleteContacts(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/contacts/" + id}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ************** Advance Diesel Challan  **********************************

  // ---------------------------------Fetch Advance Diesel Challan List ----------------------------------------
  async fetchAllAdvanceDieselChallan() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/advancediesels/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // -------------------------- Fetch Filter Advance Diesel Challan Data -----------------------------------------
  async fetchAllFilterAdvanceDieselChallan(challanData) {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/advancediesels/datarec/filters"}`, { params: challanData, }
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //----------------------Get Advance Diesel Challan By Id -------------------------------------
  async fetchAdvanceDieselChallanById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/advancediesels/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },

  //----------------------Get Advance Diesel Challan By Id -------------------------------------
  async fetchAdvanceDieselChallanByVecId(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/advancediesels/vech/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Update Advance Diesel Challan  ----------------------------------------
  async createAdvanceDieselChallan(cityData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/advancediesels"}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },
  // async saveAdvanceDieselChallan(advanceChallanDetails) {
  //   console.log("object",advanceChallanDetails.id);
  //   const instance = getAxios();
  //   const { data } = await instance.put(
  //     `${constants.API_BASE_URL}/api/advancediesels/${advanceChallanDetails?.id}`,
  //     advanceChallanDetails
  //   );
  //   if (data) {
  //     return data;
  //   }
  //   return null;
  // }, 

  async saveAdvanceDieselChallan(contacts) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/advancediesels/" + contacts.id}`,
      contacts
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Advance Diesel Challan  ----------------------------------------//
  async deleteAdvanceDieselChallan(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/advancediesels/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },

  // ************** Client Invoice Challan  **********************************

  //................... Fetch All Challan Counts ................................
  async fetchChallanInvoiceCount(filterDate) {
    console.log("Filter Date on Api", filterDate)
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL}/api/clientinvoices/total/${filterDate.month}/${filterDate.financial_year_id}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //................... Fetch All Challan Counts ................................
  async fetchChallanInvoiceCountPay(filterDate) {
    console.log("Filter Date on Api", filterDate)
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL}/api/clientinvoicepayments/total/${filterDate.month}/${filterDate.financial_year_id}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // ---------------------------------Fetch Client Invoice List ----------------------------------------
  async fetchAllClientInvoice() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clientinvoices/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // -------------------------- Fetch Filter Client Invoice -----------------------------------------
  async fetchAllFilterClientInvoice(challanData) {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clientinvoices/datarec/filters"}`, { params: challanData, }
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //----------------------Get Client Invoice By Id -------------------------------------
  async fetchClientInvoiceById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clientinvoices/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },


  //----------------------Get Client Invoice By Status (Pending) -------------------------------------
  async fetchClientInvoiceByPendingStatus() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clientinvoices/status/pending"}`);
    if (data) {
      return data;
    }
    return null;
  },


  //----------------------Get Client Status Invoice By Id (Pending) -------------------------------------
  async fetchClientInvoiceStatusById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clientinvoices/status/pending/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Update Client Invoice  ----------------------------------------
  async createClientInvoice(cityData) {
    console.log("Post_API", cityData);
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/clientinvoices"}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },
  async saveClientInvoice(cityData) {
    console.log("object", cityData);
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/clientinvoices/" + cityData.id}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Client Invoice  ----------------------------------------//
  async deleteClientInvoice(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/clientinvoices/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },


  // ************** Client Invoice Payment  **********************************

  // ---------------------------------Fetch Client Invoice Payment  ----------------------------------------
  async fetchAllClientInvoicePayment() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clientinvoicepayments/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // -------------------------- Fetch Filter Client Invoice Payment -----------------------------------------
  async fetchAllFilterClientInvoicePayment(challanData) {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clientinvoicepayments/datarec/filters"}`, { params: challanData, }
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //----------------------Get Client Invoice Payment By Id -------------------------------------
  async fetchClientInvoicePaymentById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clientinvoicepayments/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Update Client Invoice Payment  ----------------------------------------
  async createClientInvoicePayment(cityData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/clientinvoicepayments"}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },
  async saveClientInvoicePayment(cityData) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/clientinvoicepayments/" + cityData.id}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Client Invoice Payment  ----------------------------------------//
  async deleteClientInvoicePayment(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/clientinvoicepayments/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },

  // -------------------------- Driver Payment ----------------------------------

  // ---------------------------------Fetch Driver Payment  ----------------------------------------
  async fetchAllDriverPayment() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/driverpayments/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // -------------------------- Fetch Filter Client Invoice Payment -----------------------------------------
  async fetchAllFilterDriverPayment(challanData) {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/driverpayments/datarec/filters"}`, { params: challanData, }
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //----------------------Get Driver By Status (Pending) -------------------------------------
  async fetchDriverPaymentByPendingStatus() {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/driverpayments/status/pending"}`);
    if (data) {
      return data;
    }
    return null;
  },

  //----------------------Get Client Invoice Payment By Id -------------------------------------
  async fetchDriverPaymentById(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/driverpayments/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Update Client Invoice Payment  ----------------------------------------
  async createDriverPayment(cityData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/driverpayments"}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },
  async saveDriverPayment(cityData) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/driverpayments/" + cityData.id}`,
      cityData
    );
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Client Invoice Payment  ----------------------------------------//
  async deleteDriverPayment(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/driverpayments/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },
  //--------------------------- End Here Driver Payment ----------------------------------------
  // ************** Client Invoice LineItems  **********************************

  // ---------------------------------Fetch Client Invoice LineItems List ----------------------------------------
  async fetchAllClientInLineItems() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clientinvoicelineitems/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  //----------------------Get Client Invoice Lineitems By Id -------------------------------------
  async fetchByClientInvoiceLineItemsId(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clientinvoicelineitems/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },


  //----------------------Get Client Invoice Lineitems By Client Id -------------------------------------
  async fetchByClientId(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clientinvoicelineitems/client/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },


  //----------------------Get Client Invoice Lineitems By Client Id (PDF) -------------------------------------
  async fetchByClientIdOnPDf(id) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/clientinvoicelineitems/client/adchall/" + id}`);
    if (data) {
      return data;
    }
    return null;
  },



  // --------------------------------- Create or Client Invoice Lineitems  ----------------------------------------
  async createClientInvoiceLineItems(cityData) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/clientinvoicelineitems"}`,
      cityData
    );

    if (data) {
      return data;
    }
    return null;
  },
  async saveClientInvoiceLineItems(cityData) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/clientinvoicelineitems/" + cityData.id}`,
      cityData
    );

    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Client Invoice Lineitems  ----------------------------------------//
  async deleteClientInvoiceLineItems(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/clientinvoicelineitems/" + id}`
    )
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------------------- Reports ------------------------------------------------------

  async fetchReports(reportname) {
    console.log("Report Data Params", reportname);
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/challans/reports/relatedtasks/tasks", {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify(reportname)

    });
    //////(response)
    const result = await response.json();
    //////(result);
    if (result.length > 0) {
      //////(result)
      return result;
    }
    return null;

  },

  //---------------------------------Reports End Here -----------------------------------------------------
  //................... Create Backup ................................
  async createBackup(lead) {
    const token = localStorage.getItem("token");

    let response = await fetch(constants.API_BASE_URL + "/api/backup", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(lead),
    });
    return await response.json();
  },

  //................... Fetch Backup ................................
  async fetchBackups() {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/backup", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //...................  Download Backup ................................
  async downloadBackupFile(filename) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/backup/download/" + filename,
      {
        method: "GET",
        //mode: "cors",

        headers: {
          Authorization: token,
        },
      }
    );
    const fileBody = await response.blob();
    return fileBody;
  },

  //...................  Delete Backup ................................
  async deleteBackupFile(filename) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/backup/delete/" + filename}`
    );
    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // ---------------------------- Tyre Module API STARTS HERE PHASE-2 ------------------------------------------------
  // ************** tyreallotments  **********************************

  // ---------------------------------Fetch tyreallotments List ----------------------------------------
  async fetchAllTyreMaster() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/tyreallotments/"}`
    );
    if (data.status === 401) {
      authApi.logout();
    }
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // --------------------------------- Create or Update tyreallotments  ----------------------------------------
  async createTyreMaster(isTyreMaster) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/tyreallotments"}`,
      isTyreMaster
    );
    if (data.status === 401) {
      authApi.logout();
    }
    console.log(data);
    if (data) {
      return data;
    }
    return null;
  },
  async saveTyreMaster(isTyreMaster) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/tyreallotments/" + isTyreMaster.id}`,
      isTyreMaster
    );
    if (data.status === 401) {
      authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete tyreallotments  ----------------------------------------//
  async deleteTyreMaster(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/tyremasters/" + id}`
    );
    if (data.status === 401) {
      authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },

  // Purchase API STARTS HERE
  //..... Fetch Inventory ........
  async fetchInventoryDataForDashBoard({ product, branch, month, year }) {
    const instance = getAxios();
    const queryParams = new URLSearchParams({ product: product || '', branch: branch || '' });

    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/common/inventory-data/${month}/${year}/?${queryParams?.toString()}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch purchase data........
  async fetchPurchaseDataForDashBoard({ month, year }) {
    // Get axios Instance
    const currentDate = new Date();
    month = currentDate.getMonth() + 1; // January is 0
    year = currentDate.getFullYear();

    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/common/purchase-data/${month}/${year}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  // ************************ PurchaseOrder ********************************************
  // --create PurchaseOrder--
  async createPurchaseOrder(record) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/purchase-orders"}`,
        record
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //   //................... Fetch All Leads Current Month Wise ................................

  async fetchPurchaseOrderByCurrentMonth(filterDate) {
    console.log("HelloWorld", filterDate);
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL}/api/purchase-orders/currentmonth/${filterDate.month}/${filterDate.year}`
    );

    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // --create PurchaseOrder--
  async createPurchaseOrder(record) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/purchase-orders"}`,
        record
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // update PurchaseOrder
  async savePurchaseOrder(record) {
    const instance = getAxios();
    try {

      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/purchase-orders/" + record.id}`,
        record
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //..... Fetch PurchaseOrders ........
  async fetchPurchaseOrders(filterDate) {
    console.log("fetchPurchaseOrders filterDate == ", filterDate)
    const instance = getAxios();
    try {
      // const { data } = await instance.get(
      //   `${constants.API_BASE_URL + "/api/purchase-orders",{params:filterDate}}`
      // );

      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/purchase-orders`, { params: filterDate ? filterDate : null }
      );
      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch PurchaseOrder By ID ........
  async fetchPurchaseOrderById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/purchase-orders/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // Fetch PurchaseOrders By DateRange
  async fetchPurchaseOrdersByDateRange(fromDate, toDate) {
    const instance = getAxios();
    const queryParams = new URLSearchParams({ from: fromDate, to: toDate });
    // console.log('queryParams', queryParams.toString());
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/purchase-orders/date_range/?${queryParams?.toString()}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //..... Fetch Products to compare By Contact ID ........
  async compareProductsByContactId(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/purchase-orders/compare-products/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ---Delete PurchaseOrder By ID
  async deletePurchaseOrderById(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/purchase-orders/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },
  // ************************ PurchaseOrderLineItem ********************************************

  // --create PurchaseOrderLineItem--
  async createPurchaseOrderLineItem(record) {
    delete record.product_name;
    delete record.catogry_id;
    delete record.catogry_name;
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/purchase-order-line-items"}`,
        record
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // update PurchaseOrderLineItem
  async savePurchaseOrderLineItem(record) {
    delete record.product_name;
    delete record.catogry_id;
    delete record.catogry_name;
    const instance = getAxios();
    try {

      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/purchase-order-line-items/" + record.id}`,
        record
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //..... Fetch PurchaseOrderLineItems ........
  async fetchPurchaseOrderLineItems() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/purchase-order-line-items"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch PurchaseOrderLineItem By ID ........
  async fetchPurchaseOrderLineItemById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/purchase-order-line-items/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //..... Fetch PurchaseOrderLineItem By Purchase Order (parent) ID ........
  async fetchPurchaseLineItemsByParentId(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/purchase-order-line-items/purchase-order/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // Fetch PurchaseOrderLineItems By DateRange
  async fetchPurchaseOrderLineItemsByDateRange(fromDate, toDate) {
    const instance = getAxios();
    const queryParams = new URLSearchParams({ from: fromDate, to: toDate });
    // console.log('queryParams', queryParams.toString());
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/purchase-order-line-items/date_range/?${queryParams?.toString()}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ---Delete PurchaseOrderLineItem By ID
  async deletePurchaseOrderLineItemById(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/purchase-order-line-items/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // ************************ PurchaseOrderLineItem End Here ***********************************

  // ************************ Users ***********************************
  //..... Fetch Users ........
  async fetchUsers() {
    console.log("fetch user")
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/users"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  async createUser(user) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/auth/create_user"}`,
        user
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //........ Fetch Lead By Id .........
  async fetchUserById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/auth/users/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //....... Save Login Users ...................................
  async saveUser(user) {
    const instance = getAxios();
    try {
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/auth/" + user.id}`,
        user
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },
  // ************************ Users End Here ***********************************

  // *******************************Messages******************************************

  //   //................... Create Messages ................................
  async createMessage(messages) {
    const instance = getAxios();
    try {
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/messages"}`,
        messages
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  // .......... All Messages .............................
  async fetchMessages(pid) {
    const instance = getAxios();
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/messages/" + pid + "/*"}`
    );
    if (data) {
      return data;
    }
    return null;
  },

  // fetch Unread message
  async fetchUnreadMessages() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/messages/unread"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  async deleteMessage(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/messages/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  async markReadMessage(notificationId) {
    const instance = getAxios();
    try {
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/messages/markread/" + notificationId}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;

  },

  async deletePushNotification(notificationId) {
    const instance = getAxios();
    try {
      const { data } = await instance.delete(
        `${constants.API_BASE_URL + "/api/messages/markdelete/" + notificationId}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },
  // ------------------------------ Category --------------------------------
  // ************** Category  **********************************

  //---------------------------------------Active Category List-----------------------------------
  async fetchAllCategoryActive() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/categories/active"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },
  // ---------------------------------Fetch Category List ----------------------------------------
  async fetchAllCategory() {
    const instance = getAxios();
    //console.log(instance)
    const { data } = await instance.get(
      `${constants.API_BASE_URL + "/api/categories/"}`
    );
    //console.log(data,"test");
    if (data.status === 401) {
      authApi.logout();
    }

    if (data.length > 0) {
      return data;
    }
    return null;
  },

  // ---------------------------------Create or Update Categories  ----------------------------------------
  async createCategory(isCategory) {
    const instance = getAxios();
    const { data } = await instance.post(
      `${constants.API_BASE_URL + "/api/categories"}`,
      isCategory
    );
    if (data.status === 401) {
      authApi.logout();
    }
    console.log(data);
    if (data) {
      return data;
    }
    return null;
  },
  async saveCategories(iscategories) {
    const instance = getAxios();
    const { data } = await instance.put(
      `${constants.API_BASE_URL + "/api/categories/" + iscategories.id}`,
      iscategories
    );
    if (data.status === 401) {
      authApi.logout();
    }
    console.log("data", data);
    if (data) {
      return data;
    }
    return null;
  },

  // ------------------------ Delete Category ----------------------------------------//
  async deleteCategory(id) {
    const instance = getAxios();
    const { data } = await instance.delete(
      `${constants.API_BASE_URL + "/api/categories/" + id}`
    );
    if (data.status === 401) {
      authApi.logout();
    }
    if (data) {
      return data;
    }
    return null;
  },
  // // *******************************Product Starts here**********************************

  //................... Create Product ................................
  async createProduct(record) {
    const instance = getAxios();
    try {
      const { data } = await instance.post(
        `${constants.API_BASE_URL + "/api/products/"}`,
        record
      );
      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // update product
  async saveProduct(record) {
    const instance = getAxios();
    try {
      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/products/" + record.id}`,
        record
      );
      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //..... Fetch Products ........
  async fetchProducts() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/products"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch Product By ID ........
  async fetchProductById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/products/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ---Delete Product By ID
  async deleteProductById(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/products/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //   //************************ files ***********************************//

  async createFile(pid, formData) {
    // console.log("FormData", formData);
    const token = localStorage.getItem("token");
    console.log("formData == ", formData)
    try {
      let response = await fetch(constants.API_BASE_URL + "/api/files/" + pid, {
        method: "POST",
        mode: "cors",
        headers: {
          Authorization: token,
        },
        body: formData,
      });

      if (response.ok) {
        return await response.json();
      } else {
        // Handle different response statuses
        const errorData = await response.json();
        throw new Error(`Error ${response.status}: ${errorData.message}`);
      }
    } catch (error) {
      console.error("File upload failed", error);
      throw error;
    }
  },

  async saveFiles(file) {
    // console.log("File on Update", file);
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/files/" + file.id,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(file),
      }
    );

    return await response.json();
  },

  //   //************Download File ************ */
  async downloadFiles(fileid, foldername) {
    ////console.log("save", fileid);
    const token = localStorage.getItem("token");
    let response = await fetch(
      `${constants.API_BASE_URL}/api/files/${fileid}/${foldername}/download`,

      {
        method: "GET",
        //mode: "cors",

        headers: {
          Authorization: token,
        },
      }
    );
    const fileBody = await response.blob();
    return fileBody;
  },

  //--------------- Fetch All Files Folder wise & All ----------------------------------------
  async fetchFiles(parentId, folderName) {
    // console.log("--foldername in APi Side--", folderName);
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/files/" + parentId + "/" + folderName + "/all", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
    );

    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  async fetchPrimaryImages(parentId, folderName) {
    console.log("--foldername in APi Side--", parentId);
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/files/primaryphotos/" + parentId,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    const result = await response.json();
    ////console.log('result', result);
    ////console.log(response)
    if (result) {
      return result;
    }
    return null;
  },

  //eslint-disable-next-line
  async deleteFile(id) {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/files/" + id, {
      method: "DELETE",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    return await response.json();
  },

  // ************************ Inventory Start Here ***********************************

  //..... Fetch Inventory ........
  async fetchInventory() {
    const instance = getAxios();
    try {
      const { data } = await instance.get(
        `${constants.API_BASE_URL + "/api/inventory/view"}`
      );

      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  // ************************ ServiceOrder ********************************************

  // --create ServiceOrder--

  async createServiceOrder(record) {
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/service-orders"}`,
        record
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },


  //..... Fetch ServiceOrders ........
  async fetchServiceOrders(filterDate) {
    console.log("fetchPurchaseOrders filterDate == ", filterDate)
    const instance = getAxios();
    try {
      // const { data } = await instance.get(
      //   `${constants.API_BASE_URL + "/api/purchase-orders",{params:filterDate}}`
      // );

      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/service-orders`, { params: filterDate ? filterDate : null }
      );
      console.log("sh service data == ", data)
      if (data?.length > 0) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }

    return null;
  },

  //..... Fetch ServiceOrder  By ID ........
  async fetchServiceOrderById(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/service-orders/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //Create this api by shahir hussain for customer invoice details 13-05-2025
  //comment by shahir hussain
  // async customerInvoice(id) {
  //   const instance = getAxios();
  //   try {
  //     const response = await instance.get(
  //       `${constants.API_BASE_URL + "/api/service-orders/customer_invoice_detail/" + id}`
  //     );
  //     if (response?.data) {
  //       return response?.data;
  //     }
  //   } catch (error) {
  //     if (error?.response?.status === 401) {
  //       authApi.logout();
  //     }
  //     console.log(error.response);
  //     return null;
  //   }
  //   return null;
  // },


  // update saveServiceOrder
  async saveServiceOrder(record) {
    const instance = getAxios();
    try {

      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/service-orders/" + record.id}`,
        record
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // ---Delete PurchaseOrder By ID
  async deleteServiceOrderById(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/service-orders/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // ************************ ServiceOrder End Here ***********************************   

  // ************************ ServiceOrderLineItem ********************************************

  // -- create createServiceOrderLineItem --
  async createServiceOrderLineItem(record) {
    delete record.product_name;
    delete record.catogry_id;
    delete record.catogry_name;
    const instance = getAxios();
    try {
      const response = await instance.post(
        `${constants.API_BASE_URL + "/api/service-order-line-items"}`,
        record
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  // update ServiceOrderLineItem
  async saveServiceOrderLineItem(record) {
    delete record.product_name;
    delete record.catogry_id;
    delete record.catogry_name;
    const instance = getAxios();
    try {

      const { data } = await instance.put(
        `${constants.API_BASE_URL + "/api/service-order-line-items/" + record.id}`,
        record
      );

      if (data) {
        return data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  //..... Fetch ServiceOrderLineItem By Service Order (parent) ID ........
  async fetchServiceLineItemsByParentId(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/service-order-line-items/service-order/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  //Create this api by shahir hussain for customer invoice details 13-05-2025
  async customerInvoice(id) {
    const instance = getAxios();
    try {
      const response = await instance.get(
        `${constants.API_BASE_URL + "/api/service-order-line-items/customer_invoice_detail/" + id}`
      );
      console.log("get response == ", response)
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return null;
    }
    return null;
  },

  // ---Delete ServiceOrderLineItem By ID
  async deleteServiceOrderLineItemById(id) {
    const instance = getAxios();
    try {
      const response = await instance.delete(
        `${constants.API_BASE_URL + "/api/service-order-line-items/" + id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.log(error.response);
      return { errors: error?.response?.data?.errors };
    }
    return null;
  },

  async fetchInventoryNotification(productStock) {
    const instance = getAxios();
    try {
      console.log("productStock == ", productStock);

      // Ensure productStock is valid
      if (!productStock) {
        console.warn("Invalid productStock:", productStock);
        return null;
      }

      const { data } = await instance.get(
        `${constants.API_BASE_URL}/api/inventory/Notifications`,
        {
          params: {
            productStock: productStock
          }
        }
      );
      console.log("dekte h == ", data)

      console.log("Fetched inventory data: ", data);
      return data;

    } catch (error) {
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.error("Inventory fetch error: ", error.response || error);
      return null;
    }

    return null;
  },

  // ******************************* Payments ******************************************

  // ................... Create Payments ................................
  async createPayment(payments) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.post(
        `${constants.API_BASE_URL}/api/payments/`,
        payments
      );
      // If payment created successfully
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If an error occurs
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.error("Error creating payment:", error.response);
    }
    return null;
  },

  // ................... Save Payments ................................
  async savePayment(payments) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.put(
        `${constants.API_BASE_URL}/api/payments/${payments.id}`,
        payments
      );
      // If payment saved successfully
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If an error occurs
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.error("Error saving payment:", error.response);
    }
    return null;
  },

  // ................... Fetch All Payments ................................
  async fetchPayments(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/payments/parent/${id}`
      );
      // If unauthorized, logout
      if (response?.data?.status === 401) {
        authApi.logout();
      }
      // Return payments data if available
      if (response?.data?.length > 0) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching payments:", error.response);
    }
    return null;
  },

  // ................... Fetch All Payments (Order Wise) ................................
  async fetchOrderWisePayments(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/orders/payments/${id}`
      );
      if (response?.data?.status === 401) {
        authApi.logout();
      }
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching project payments:", error.response);
    }
    return null;
  },

  // ................... Fetch All Payments (Project Wise to show On Lead Page) ................................
  async fetchProjectPaymentsLeads(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/orders/payments/leads/${id}`
      );
      if (response?.data?.status === 401) {
        authApi.logout();
      }
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error(
        "Error fetching project payments for leads:",
        error.response
      );
    }
    return null;
  },

  // ................... Fetch Project Total Amount (Lead Page) ................................
  async fetchProjectTotalAmountLeads(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/orders/pay/leads/${id}`
      );
      if (response?.data?.status === 401) {
        authApi.logout();
      }
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error(
        "Error fetching project total amount for leads:",
        error.response
      );
    }
    return null;
  },

  // .............. Fetch Payment By Id .............................
  async fetchPaymentById(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.get(
        `${constants.API_BASE_URL}/api/payments/${id}`
      );
      if (response?.data?.status === 401) {
        authApi.logout();
      }
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching payment by ID:", error.response);
    }
    return null;
  },

  // .......... Delete Payments .............................
  async deletePayment(id) {
    // Get axios instance
    const instance = getAxios();
    try {
      // Call the API
      const response = await instance.delete(
        `${constants.API_BASE_URL}/api/payments/${id}`
      );
      if (response?.data) {
        return response?.data;
      }
    } catch (error) {
      // If unauthorized, logout
      if (error?.response?.status === 401) {
        authApi.logout();
      }
      console.error("Error deleting payment:", error.response);
    }
    return null;
  },


  //END HERE

  //End Here
};

export default instituteApi;
